import React, { useEffect, useState } from 'react'
import Header from '../../Core/Header'
import { Section } from '../../Core/Section'
import { getIncomeReport } from '../../Services/Operations/ProductAPI';
import { useSelector } from 'react-redux';

const IncomeReport = () => {
      const token = useSelector((state) => state.user.token);
      const[reportData,setReportData]=useState(null)

    const handleGetIncomeReport=async()=>{
        try {
            const response=await getIncomeReport(token)
            console.log('getIncomeReport',response);
            if(response.status===200){
                setReportData(response.data)
            }
            
        } catch (error) {
            console.log(error);
            
        }
    }

    useEffect(() => {
      handleGetIncomeReport()
    }, [])
    
  return (
       <div id="main_content">
      <Header />
      <div className="page">
        <Section />
        <div className="profit-loss-container">
          <h2 style={{fontSize:"20px"}}>Income Report</h2>
          {/* <div className="date-picker">
            <label>Select Date</label>
            <select
              value={dateRange}
              onChange={(e) => setDateRange(e.target.value)}
            >
              <option>March 6, 2025 - April 4, 2025</option>
              <option>Feb 1, 2025 - March 1, 2025</option>
            </select>
          </div> */}

          <div className="profit-summary" style={{display:"flex",justifyContent:"space-around"}}>
         
            <div className="summary-card" style={{borderRadius:"10px",backgroundColor:"#422efa",color:"white",padding:"20px",width:"280px"}}>
              <button className="export-btn" style={{borderRadius:"10px",backgroundColor:"#616161",color:"white",padding:"6px"}}>Export</button>
              <h3>Total Income</h3>
              <p className= "negative" >
                ₹ {reportData?.totalIncome}
              </p>
            </div>
          </div>

          <div className="report-sections"
          style={{display:"flex",width:"90%",gap:"10px",margin:"15px"}}>
           <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
        textAlign: "left"
      }}
    >
      <thead>
        <tr>
          <th style={{ border: "1px solid #ddd", padding: "8px" }}>ID</th>
      
          <th style={{ border: "1px solid #ddd", padding: "8px" }}>Income</th>
          <th style={{ border: "1px solid #ddd", padding: "8px" }}>Payable Amount</th>
          <th style={{ border: "1px solid #ddd", padding: "8px" }}>Due Amount</th>
          <th style={{ border: "1px solid #ddd", padding: "8px" }}>Payment Mode</th>
          <th style={{ border: "1px solid #ddd", padding: "8px" }}>Status</th>
          <th style={{ border: "1px solid #ddd", padding: "8px" }}>Created At</th>
        </tr>
      </thead>
      <tbody>
        {reportData?.payments.map((payment,ind) => (
          <tr key={payment.id}>
            <td style={{ border: "1px solid #ddd", padding: "8px" }}>{ind+1}</td>
         
            <td style={{ border: "1px solid #ddd", padding: "8px" }}>₹{payment.income}</td>
            <td style={{ border: "1px solid #ddd", padding: "8px" }}>₹{payment.payableAmount}</td>
            <td style={{ border: "1px solid #ddd", padding: "8px" }}>₹{payment.dueAmount}</td>
            <td style={{ border: "1px solid #ddd", padding: "8px" }}>{payment.paymentMode || "N/A"}</td>
            <td style={{ border: "1px solid #ddd", padding: "8px" }}>
              {payment.status === 1 ? "Paid" : "Pending"}
            </td>
            <td style={{ border: "1px solid #ddd", padding: "8px" }}>
              {new Date(payment.createdAt).toLocaleString()}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
          </div>
        </div>
      </div>
    </div>
  )
}

export default IncomeReport
